import Image from 'next/image'
import React from 'react'
import { TrackerCardProps } from '../index'

export const TrackerCard = ({ imageURL, title }: TrackerCardProps) => {
    return (
        <div className="flex flex-col text-center max-w-[100px]">
            <div className="p-1 rounded-2xl mb-4 flex items-center justify-center">
                <Image
                    alt={`${title} card image`}
                    src={imageURL}
                    quality={100}
                    width="100px"
                    height="100px"
                    objectFit="cover"
                    objectPosition="center"
                />
            </div>
            <p className="text-sm font-medium text-black">{title}</p>
        </div>
    )
}
